import { useLocale } from '../i18n/LocaleProvider'
import './HowItWorksSection.css'

const steps = [
  { n: '1', title: 'Discovery Call', body: 'Tell us about your product, your target market, and your goals. We\'ll assess fit and outline a recommended approach.' },
  { n: '2', title: 'Japan GTM Strategy', body: 'Map your ideal customer profile, identify priority channels, and align on deliverables. We give you a clear Japan market entry playbook.' },
  { n: '3', title: 'Execution', body: 'Build your JP presence — LP, materials, SNS accounts, sales outreach — fully in Japanese. You review, we ship.' },
  { n: '4', title: 'Growth & Reporting', body: 'Bi-monthly KPI reports. Retainer clients get ongoing SNS management and Japanese-language customer success support.' },
]

export default function HowItWorksSection() {
  const { t } = useLocale()
  return (
    <section className="hiw-section">
      <div className="container">
        <div className="section-header">
          <span className="section-jp">{t("How It Works")}</span>
          <h2>{t('From first call to your first Japanese customer')}</h2>
        </div>

        <div className="hiw-steps">
          {steps.map((s) => (
            <div className="hiw-step" key={s.n}>
              <div className="hiw-num">{s.n.padStart(2, '0')}</div>
              <div className="hiw-step-content">
                <h3>{t(s.title)}</h3>
                <p>{t(s.body)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
